import {
  OPERATOR_SURAT,
  PENGENDALI_SURAT,
  KABAG,
  DIREKTUR,
  DIREKTUR_UTAMA,
  KOMISARIS_UTAMA,
  KOMISARIS_INDEPENDEN
} from './roles';

const canCreateSuratMasuk = (role) => {
  const allowedRoles = [OPERATOR_SURAT, PENGENDALI_SURAT];
  return allowedRoles.includes(String(role));
}
const canParallelDisposition = (role) => {
  const allowedRoles = [KABAG];
  return allowedRoles.includes(String(role));
}
const canParafDisposition = (role) => {
  const allowedRoles = [PENGENDALI_SURAT, KABAG, DIREKTUR, DIREKTUR_UTAMA];
  return allowedRoles.includes(String(role));
}
const canPengajuanDisposition = (role) => {
  const allowedRoles = [OPERATOR_SURAT, PENGENDALI_SURAT];
  return allowedRoles.includes(String(role));
}
const isHeadPosition = (role) => String(role) === DIREKTUR_UTAMA;

const canCreateSuratKeluar = (role) => {
  const notAllowedRoles = [KOMISARIS_UTAMA, KOMISARIS_INDEPENDEN];
  return !notAllowedRoles.includes(String(role));
}

export {
  canCreateSuratMasuk,
  canParallelDisposition,
  isHeadPosition,
  canPengajuanDisposition,
  canParafDisposition,
  canCreateSuratKeluar
}
